import { createApp, defineAsyncComponent, markRaw } from "vue";

import Router from "./router";
import store from "./store";
import axios from "axios";
import _ from "lodash";
window._ = _;
import Echo from "laravel-echo";
import { useStore } from "vuex";
import mitt from "mitt";
import "./index.css";
import moment from "moment-timezone";
import Big from "big.js";
import Tracker from "@openreplay/tracker";
import trackerVuex from "@openreplay/tracker-vuex";
import * as Sentry from "@sentry/vue";
import { httpClientIntegration } from "@sentry/integrations";
import Pusher from "pusher-js";
import { createPinia } from "pinia";
import { useCurrentUserStore } from "./pinia/CurrentUserStore";
import CustomButton from "@/components/basics/CustomButton.vue";
import StandardTable from "@/components/basics/StandardTable.vue";
import Searchbar from "@/components/basics/Searchbar.vue";
import Pagination from "@/components/basics/Pagination.vue";
import TextInput from "@/components/basics/TextInput.vue";
import SimpleLoadingIcon from "@/components/basics/SimpleLoadingIcon.vue";
import DeleteModal from "@/components/basics/DeleteModal.vue";
import DropdownMenu from "@/components/basics/DropdownMenu.vue";
import DropdownSearchMenu from "@/components/basics/DropdownSearchMenu.vue";
import ErrorNotification from "@/components/basics/error-notification.vue";
import CancelSaveButton from "@/components/basics/CancelSaveButton.vue";
import CenterEdit from "@/components/basics/center-edit.vue";
import Card from "@/components/basics/Card.vue";
import Translation from "@/components/basics/Translation.vue";
import { useActionStore } from "./pinia/ActionStore";
import { useLanguageStore } from "./pinia/LanguageStore";
import { getSetting, buildCache } from "./components/settings/useTreeSetting";
import.meta.glob(["../css/**", "../images/**", "../fonts/**"]);
import { can as canfunc, cannot as cannotfunc } from '@/components/permissions-handler/helpers/usePermissions'
//import CtkDateTimePicker from './components2/VueCtkDateTimePicker/VueCtkDateTimePicker'; //https://github.com/crutch12/vue-ctk-date-time-picker/tree/feat/vue3

//import KooiMainDisplay from "./components/kooi/KooiMainDisplay.vue";
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// define a mixin object

const app = createApp({
    setup() {
        const currentUser = useCurrentUserStore();
        const actionStore = useActionStore();
        const store = useStore();
        const tablePreferenceStore = useTablePreferenceStore();
        const countryStore = useCountryStore();
        const languageStore = useLanguageStore();
        return { currentUser, actionStore, store, tablePreferenceStore, countryStore, languageStore };
    },
    data() {
        return {
            system: window.system,
            production: import.meta.env.VITE_APP_SYSTEM,
            kooiid: 0,
            settings: window.pagesettings,
            internalCompanies: window.internalCompanies,
            baseurl: window.pagesettings.baseurl,
            fullReload: true,
            loadCompany: null,
            tracker: null,
            trackerActive: false,
            authenticated: false,
            debounce: {
                langupdate: null,
            },
        };
    },
    watch: {
        companyId() {
            this.clean();
            this.load();
        },
    },
    created() {
        if (
            window.pagesettings.user !== null &&
            window.pagesettings.user !== undefined &&
            window.pagesettings.user.api_token != null &&
            window.pagesettings.user.api_token !== undefined &&
            window.pagesettings.user.api_token != ""
        ) {
            this.authenticated = true;
        }

        this.$store.commit("auth/setUser", this.settings.user);
        this.currentUser.user = this.settings.user;
        Sentry.setUser({
            email: this.settings?.user?.email,
            id: this.settings.user.id,
        });

        this.$store.commit("settings/setKey", {
            key: "pagination",
            value: _.get(this.settings.user, "profile.defaults.pagination", 25),
        });
        this.$store.commit("settings/setUser", this.settings.user);
        this.$store.commit("settings/baseUrl", this.baseurl);
        let localCompany = sessionStorage.getItem("_internal_company");
        if (
            localCompany == undefined ||
            localCompany == null ||
            localCompany == ""
        ) {
            localCompany = localStorage.getItem("_internal_company");
            if (
                localCompany == undefined ||
                localCompany == null ||
                localCompany == ""
            ) {
            localCompany = this.settings.internal_company;
            }
        }
        this.$store.commit("settings/internalUserCompanyChange", localCompany);
        this.$store.commit("settings/companies", this.internalCompanies);
        const store = this.$store;
        axios.interceptors.response.use(
            function (response) {
                // Any status code that lie within the range of 2xx cause this function to trigger
                // Do something with response data
                return response;
            },
             (error) => {
                let message = undefined;
                if (error?.response?.data?.message) {
                    message = error.response.data.message;
                }
                // Any status codes that falls outside the range of 2xx cause this function to trigger
                // Do something with response error
                if (error.response && error.response.status == 401) {
                    store.commit("notifications/toast_updateOrPush", {
                        id: -1,
                        created_at: moment.now(),
                        message: message ?? "Unauthenticated",
                    });
                    location.href = this.baseurl + "/login";
                    return Promise.reject(error);
                }
                if (error.response && error.response.status == 503) {
                    window.location.reload();
                }
                if (error.response && error.response.status >= 500) {
                    store.commit("notifications/toast_updateOrPush", {
                        id: -1,
                        created_at: moment.now(),
                        message: message ?? "Server Error",
                    });
                    return Promise.reject(error);
                }
                if (error.response && error.response.status >= 400) {
                    if (error.response.status == 403) {
                        store.commit("notifications/toast_updateOrPush", {
                            id: -1,
                            created_at: moment.now(),
                            message: message ?? "No Permissions!",
                        });
                    }
                    if (error.response.status == 422) {
                        store.commit("notifications/toast_updateOrPush", {
                            id: -1,
                            created_at: moment.now(),
                            message: message ?? "Request couldn't be processed.",
                        });
                    }
                }
                if (!error.response && !(error.code == "ERR_CANCELED")) {
                    store.commit("notifications/toast_updateOrPush", {
                        id: -1,
                        created_at: moment.now(),
                        message: message ?? "Server Error",
                    });
                    return Promise.reject(error);
                }
                return Promise.reject(error);
            }
        );
    },
    mounted() {
        if (!this.authenticated) {
            return;
        }
         this.languageStore.setLocale(localStorage.getItem("_locale") ?? this.settings.locale);
        var language = {};
        var possible = [];
        try {
            possible = JSON.parse(localStorage.getItem("_locale_possibles") ?? "[]");
            language = JSON.parse(
                localStorage.getItem("_lang_" + this.languageStore.locale) ?? "{}"
            );
        } catch (e) {
            language = {};
            possible = [];
        }
        this.languageStore.translations = language;
        this.languageStore.possible = possible;
        this.languageStore.load();
        this.emitter.on("create:notification", async (data : any) => {
            if (data.id > 0) {
                this.$store.commit("notifications/updateOrPush", {
                    id: data.id ?? -1,
                    created_at: data.created_at ?? moment.now(),
                    message:
                        data.message ?? "Notification without a description.",
                });
            } else {
                this.$store.commit("notifications/toast_updateOrPush", {
                    id: data.id ?? -1,
                    created_at: data.created_at ?? moment.now(),
                    message:
                        data.message ?? "Notification without a description.",
                });
            }
        });

        this.echo
            .private("global")
            .listen("Language.LanguageUpdate", () => {
                if (this.debounce.langupdate) {
                    clearTimeout(this.debounce.langupdate);
                }
                this.debounce.langupdate = setTimeout(() => {
                    this.languageStore.load();
                }, Math.floor(Math.random() * 10));
            });
    },
    unmounted() {
        this.emitter.off("create:notification");
    },
    methods: {
        microseconds(messege = "debug") {
            console.log(messege, Date.now() / 1000);
        },
        getTrackerStatus() {
            return this.trackerActive;
        },
        startTracker() {
            if (this.trackerActive == true) {
                this.trackerActive = false;
                sessionStorage.setItem("tracker", "null");
            } else {
                if (this.tracker) {
                    clearTimeout(this.tracker);
                }
                this.tracker = setTimeout(() => {
                }, 3 * 60 * 1000);
                this.trackerActive = true;
                sessionStorage.setItem("tracker", Date.now() as any);
            }
        },
        trackerNote(value: string) {
            console.warn("TrackerNote: " + value);
        },
        clean() {
            this.$store.commit("companies/clean");
            this.$store.commit("companies/companyTypes/clean");
            this.$store.commit("products/clean");
            this.$store.commit("productcategories/clean");
            this.$store.commit("companies/addresstypes/clean");
            this.$store.commit("logisticTemplates/clean");
            this.$store.commit("currencies/clean");
            this.languageStore.clean();
            this.$store.commit("companies/beneficialAccounts/clean");
            this.$store.commit("dashboardChart/clean");
            this.$store.commit("dashboardEvents/clean");
            this.$store.commit("dashboardInbox/clean");
            this.$store.commit("dashboardInvoices/clean");
            this.$store.commit("users/clean");
            this.$store.commit("emailTemplates/cleanTemplateFilters");
            this.$store.commit("documentTypes/clean");
            this.$store.commit("apitoken/clean");
            this.countryStore.clean();
        },
        load() {
            if (!this.authenticated) {
                return;
            }

            this.$store.dispatch("products/loadProductTypes");
            this.$store.dispatch("products/load");
            this.$store.dispatch("products/loadLanguages");
            this.$store.dispatch("products/loadFormulas");
            this.$store.dispatch("productcategories/load");
            this.$store.dispatch("productcategories/loadAll");
            this.$store.dispatch("currencies/load"); // werden hier geladen wegen den user settings => currency dropdown
            this.languageStore.loadLanguages();
            this.$store.commit(
                "companies/beneficialAccounts/setCompany",
                this.companyId
            );
            this.$store.dispatch("companies/beneficialAccounts/load"); // user settings => accounts dropdown
            this.$store.dispatch("apitoken/load");
            this.$store.dispatch("emailTemplates/getEmailtemplateFilters");
            this.$store.dispatch("documentTypes/load");
            this.$store.getters["settings/getActiveCompany"]()
            this.tablePreferenceStore.clear();
             this.countryStore.loadCountries();
            this.emitter.emit("app:reload");
        },
        handleScroll(event: any) {
            // show/hide fixed kooi header menu
            let elem = document.querySelector(".kooi-container");
            if (elem != null) {
                let myScroll = elem.getBoundingClientRect().y;
                if (myScroll < -50) {
                    let topbar = document.getElementById("kooitopbar");
                    if(topbar !== null){
                        topbar.style.display =
                        "block";
                    }
                } else {
                    let topbar = document.getElementById("kooitopbar")
                    if(topbar !== null){
                        topbar.style.display =
                        "none";
                    }
                }
            }
        },
    },
    computed: {
        companyId() {
            return this.$store.state.settings.internal.user_company;
        },
    },
    provide() {
        return {
            emitter: this.emitter,
            system: this.system,
            isProduction: this.production,
            fullReload: this.load,
            baseurl : this.baseurl,
            startTracker: this.startTracker,
            trackerActive: this.trackerActive,
            getTrackerStatus: this.getTrackerStatus,
            trackerNote: this.trackerNote,
            default_currency: this.settings.system_currency,
            possiblePageSizes: this.possiblePageSizes,
            impersonator : this.settings.impersonator
        };
    },
});
// store.subscribe((mutation, state) => {
//     if (mutation.type == "lang/setLocale") {
//         localStorage.setItem("_locale", state.lang.locale);
//     }
//     if (mutation.type == "lang/set") {
//         localStorage.setItem(
//             "_lang_" + state.lang.locale,
//             JSON.stringify(state.lang.translations)
//         );
//     }
//     if (mutation.type == "lang/setPossible") {
//         localStorage.setItem(
//             "_locale_possibles",
//             JSON.stringify(state.lang.possible)
//         );
//     }
// });
import SelectInput from "@/components/basics/SelectInput.vue";
import { indexOf } from "lodash";
import { useTablePreferenceStore } from "./pinia/TablePreferenceStore";
import { useCountryStore } from "./pinia/CountryStore";
import { CurrentUserStore } from "./types/pinia/CurrentUserStore";
import { error } from "console";
import { disable_navigation } from "./helpers/General";
import { useInternalCompany } from "./helpers/useInternalCompany";

app.component("CustomButton", CustomButton);
app.component("Searchbar", Searchbar);
app.component("StandardTable", StandardTable);
app.component("pagination", Pagination);
app.component("SimpleLoadingIcon", SimpleLoadingIcon);
app.component("TextInput", TextInput);
app.component("DeleteModal", DeleteModal);
app.component("DropdownMenu", DropdownMenu);
app.component("DropdownSearchMenu", DropdownSearchMenu);
app.component("ErrorNotification", ErrorNotification);
app.component("CancelSaveButton", CancelSaveButton);
app.component("CenterEdit", CenterEdit);
app.component("SelectInput", SelectInput);
app.component("Card", Card);
app.component("Translation", Translation);

// Register everything as Async for simple switch to new version
app.component(
    "CtkDateTimePicker",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components2/VueCtkDateTimePicker/VueCtkDateTimePicker/index.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Markdownify",
    defineAsyncComponent({
        loader: () => import("@/components/markdown/Markdownify.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Dashboard",
    defineAsyncComponent({
        loader: () => import("@/components/Dashboard.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompaniesTable",
    defineAsyncComponent({
        loader: () => import("@/components/companies/CompaniesTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "BeneficialAccounts",
    defineAsyncComponent({
        loader: () => import("@/components/companies/BeneficialAccounts.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanySettings",
    defineAsyncComponent({
        loader: () => import("@/components/system/CompanySettings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "KooiSettings",
    defineAsyncComponent({
        loader: () => import("@/components/system/KooiSettings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PdfTranslations",
    defineAsyncComponent({
        loader: () => import("@/components/system/PdfTranslations.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardOrders",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/DashboardOrders.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "EmailTable",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/EmailTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceTable",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/InvoiceTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PurchaseTable",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/PurchaseTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "SendMailModal",
    defineAsyncComponent({
        loader: () => import("@/components/email/SendMailModal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "EmailViewModal",
    defineAsyncComponent({
        loader: () => import("@/components/email/EmailViewModal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Login",
    defineAsyncComponent({
        loader: () => import("@/components/Login.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "BrowserTabBar",
    defineAsyncComponent({
        loader: () =>
            import("@/components/navigation/browserTabs/BrowserTabBar.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "SideMenuLink",
    defineAsyncComponent({
        loader: () => import("@/components/navigation/SideMenuLink.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "SideMenu",
    defineAsyncComponent({
        loader: () => import("@/components/navigation/SideMenu.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TopMenu",
    defineAsyncComponent({
        loader: () => import("@/components/navigation/TopMenu.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceCompany",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceCompany.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceTotal",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceTotal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoicePositions",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoicePositions.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceFooter",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceFooter.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceHeader",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceHeader.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceCreate",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceCreate.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoiceProductRow",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/InvoiceProductRow.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ReleaseTable",
    defineAsyncComponent({
        loader: () => import("@/components/releases/ReleaseTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ReleaseCompany",
    defineAsyncComponent({
        loader: () => import("@/components/releases/ReleaseCompany.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "QuickStatusSettings",
    defineAsyncComponent({
        loader: () =>
            import("@/components/quickstatus/QuickStatusSettings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Accordion",
    defineAsyncComponent({
        loader: () => import("@/components/basics/Accordion.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CustomTable",
    defineAsyncComponent({
        loader: () => import("@/components/basics/CustomTable.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CustomTableSmall",
    defineAsyncComponent({
        loader: () => import("@/components/basics/CustomTableSmall.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TextareaInput",
    defineAsyncComponent({
        loader: () => import("@/components/basics/TextareaInput.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "AutoloadDiv",
    defineAsyncComponent({
        loader: () => import("@/components/basics/AutoloadDiv.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CustomAlert",
    defineAsyncComponent({
        loader: () => import("@/components/basics/CustomAlert.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Pagination",
    defineAsyncComponent({
        loader: () => import("@/components/basics/Pagination.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UserList",
    defineAsyncComponent({
        loader: () => import("@/components/basics/UserList.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "e",
    defineAsyncComponent({
        loader: () => import("@/components/basics/e.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "MultiSelectField",
    defineAsyncComponent({
        loader: () => import("@/components/basics/MultiSelectField.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "Sidebar",
    defineAsyncComponent({
        loader: () => import("@/components/layouts/Sidebar.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "ShinkibaMain",
    defineAsyncComponent({
        loader: () => import("@/components/shinkiba/shinkiba-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "MycroftMain",
    defineAsyncComponent({
        loader: () => import("@/components/mycroft/mycroft-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "AllocationView",
    defineAsyncComponent({
        loader: () => import("@/components/mycroft/allocation-view.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "EmailtemplatesEdit",
    defineAsyncComponent({
        loader: () =>
            import("@/components/emailtemplates/emailtemplates-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "EmailtemplatesPage",
    defineAsyncComponent({
        loader: () =>
            import("@/components/emailtemplates/emailtemplates-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CommissionMain",
    defineAsyncComponent({
        loader: () => import("@/components/commission/commission-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CommisionBlockPercentage",
    defineAsyncComponent({
        loader: () =>
            import("@/components/commission/commission-block-percentage.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CommissionOfMargin",
    defineAsyncComponent({
        loader: () =>
            import("@/components/commission/commission-of-margin.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "HelpApp",
    defineAsyncComponent({
        loader: () => import("@/components/help/help-app.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "HelpMarkdownifyHtml",
    defineAsyncComponent({
        loader: () => import("@/components/help/help-markdownify-html.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyContacts",
    defineAsyncComponent({
        loader: () => import("@/components/companies/company-contacts.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyContactList",
    defineAsyncComponent({
        loader: () => import("@/components/companies/includes/Contact.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyEditSmall",
    defineAsyncComponent({
        loader: () => import("@/components/companies/company-edit-small.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyImport",
    defineAsyncComponent({
        loader: () => import("@/components/companies/company-import.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyEdit",
    defineAsyncComponent({
        loader: () => import("@/components/companies/company-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "MiniStatistic",
    defineAsyncComponent({
        loader: () => import("@/components/companies/mini-statistic.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyLogisticSteps",
    defineAsyncComponent({
        loader: () =>
            import("@/components/companies/company-logistic-steps.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyInternalInformations",
    defineAsyncComponent({
        loader: () =>
            import("@/components/companies/company-internal-informations.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CompanyBaseInfos",
    defineAsyncComponent({
        loader: () => import("@/components/companies/company-base-infos.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TextblocksOverview",
    defineAsyncComponent({
        loader: () => import("@/components/textblocks/textblocks-overview.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TextblockEdit",
    defineAsyncComponent({
        loader: () => import("@/components/textblocks/textblock-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "SystemSettingsPage",
    defineAsyncComponent({
        loader: () => import("@/components/system/system-settings-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CountriesEdit",
    defineAsyncComponent({
        loader: () => import("@/components/countries/countries-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CountriesPage",
    defineAsyncComponent({
        loader: () => import("@/components/countries/countries-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "RoundcubeMails",
    defineAsyncComponent({
        loader: () => import("@/components/roundcube/roundcube-mails.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardMain",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardInbox",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-inbox.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardInvoices",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-invoices.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardChart",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-chart.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardKooiList",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-kooi-list.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DashboardEvents",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/dashboard-events.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "EventsList",
    defineAsyncComponent({
        loader: () => import("@/components/dashboard/events-list.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UserSettings",
    defineAsyncComponent({
        loader: () => import("@/components/user/user-settings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UserEdit",
    defineAsyncComponent({
        loader: () => import("@/components/user/user-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UserNotifications",
    defineAsyncComponent({
        loader: () => import("@/components/user/user-notifications.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UserPage",
    defineAsyncComponent({
        loader: () => import("@/components/user/user-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "NoteHistory",
    defineAsyncComponent({
        loader: () => import("@/components/note/note-history.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "SentNote",
    defineAsyncComponent({
        loader: () => import("@/components/note/sent-note.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "receivedNote",
    defineAsyncComponent({
        loader: () => import("@/components/note/received-note.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "NoteHelp",
    defineAsyncComponent({
        loader: () => import("@/components/note/note-help.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "NoteMain",
    defineAsyncComponent({
        loader: () => import("@/components/note/note-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticBlocksList",
    defineAsyncComponent({
        loader: () => import("@/components/logistics/logistic-blocks-list.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockSimpleCosts",
    defineAsyncComponent({
        loader: () =>
            import("@/components/logistics/logistics-block-simple-costs.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticSummary",
    defineAsyncComponent({
        loader: () => import("@/components/logistics/logistic-summary.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockSimpleTransportDestination",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-simple-transport-destination.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockInfo",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-info.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockTodos",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-todos.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockOrderInfo",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-order-info.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockCashDisbursement",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-cash-disbursement.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "logisticsBlockCosts",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-costs.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "logisticsBlockCostsVessel",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-costs-vessel.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "logisticsBlockCostsLoading",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-costs-loading.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "logisticsBlockCostsSimple",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-costs-simple.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);


app.component(
    "LogisticsBlockTrucker",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-trucker.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "TrackDatePoints",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/Tracking/TrackDatePoints.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "TrackDatePointsCompany",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/Tracking/TrackDatePointsCompany.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);

app.component(
    "TrackDatePointsWithPort",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/Tracking/TrackDatePointsWithPort.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);


app.component(
    "LogisticSettings",
    defineAsyncComponent({
        loader: () => import("@/components/logistics/logistic-settings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsSelect",
    defineAsyncComponent({
        loader: () => import("@/components/logistics/logistics-select.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticTemplateEdit",
    defineAsyncComponent({
        loader: () =>
            import("@/components/logistics/logistic-template-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsMain",
    defineAsyncComponent({
        loader: () => import("@/components/logistics/logistics-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockSimpleTransport",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/logistics/logistics-block-simple-transport.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticTermVisualizer",
    defineAsyncComponent({
        loader: () =>
            import("@/components/logistics/logistic-term-visualizer.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LogisticsBlockCostsPerUnit",
    defineAsyncComponent({
        loader: () =>
            import("@/components/logistics/logistics-block-costs-per-unit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "QuickOffer",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/quick-offer.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "KooiTable",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/kooi-table.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "BalanceMain",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/balance-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UpcomingEvents",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/upcoming-events.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "OrderMain",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/order-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "KooiBaseData",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/kooi-base-data.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "BalanceAdder",
    defineAsyncComponent({
        loader: () => import("@/components/kooi/balance-adder.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "GroupPage",
    defineAsyncComponent({
        loader: () => import("@/components/group/group-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "GroupEdit",
    defineAsyncComponent({
        loader: () => import("@/components/group/group-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ProductCategoryEdit",
    defineAsyncComponent({
        loader: () => import("@/components/products/product-category-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ProductCategoryPage",
    defineAsyncComponent({
        loader: () => import("@/components/products/product-category-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ProductsPage",
    defineAsyncComponent({
        loader: () => import("@/components/products/products-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ProductEdit",
    defineAsyncComponent({
        loader: () => import("@/components/products/product-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PropertyEdit",
    defineAsyncComponent({
        loader: () =>
            import("@/components/products/properties/property-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PoBox",
    defineAsyncComponent({
        loader: () => import("@/components/email/po-box.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "GlobalSearch",
    defineAsyncComponent({
        loader: () => import("@/components/search/global-search.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionEdit",
    defineAsyncComponent({
        loader: () => import("@/components/conditions/condition-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionsBlockSimpleTransport",
    defineAsyncComponent({
        loader: () =>
            import(
                "@/components/conditions/conditions-block-simple-transport.vue"
            ),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionSettings",
    defineAsyncComponent({
        loader: () => import("@/components/conditions/condition-settings.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionsBlockMarkdown",
    defineAsyncComponent({
        loader: () =>
            import("@/components/conditions/conditions-block-markdown.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionsBlockDownPayment",
    defineAsyncComponent({
        loader: () =>
            import("@/components/conditions/conditions-block-down-payment.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ConditionsMain",
    defineAsyncComponent({
        loader: () => import("@/components/conditions/conditions-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "SuppliersMain",
    defineAsyncComponent({
        loader: () => import("@/components/supplier/suppliers-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "LgModalRendered",
    defineAsyncComponent({
        loader: () => import("@/components/basicmodal/lg-modal-rendered.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "mdModal",
    defineAsyncComponent({
        loader: () => import("@/components/basicmodal/md-modal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "smModal",
    defineAsyncComponent({
        loader: () => import("@/components/basicmodal/sm-modal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "lgModal",
    defineAsyncComponent({
        loader: () => import("@/components/basicmodal/lg-modal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "xlModal",
    defineAsyncComponent({
        loader: () => import("@/components/basicmodal/xl-modal.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UnitsEdit",
    defineAsyncComponent({
        loader: () => import("@/components/units/units-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "UnitsPage",
    defineAsyncComponent({
        loader: () => import("@/components/units/units-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PricelistEdit",
    defineAsyncComponent({
        loader: () => import("@/components/pricelists/pricelist-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PricelistMatrixEdit",
    defineAsyncComponent({
        loader: () =>
            import("@/components/pricelists/pricelist-matrix-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PricelistsPage",
    defineAsyncComponent({
        loader: () => import("@/components/pricelists/pricelists-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "OoiTableOverview",
    defineAsyncComponent({
        loader: () => import("@/components/ooi/ooi-table-overview.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "PdfValidation",
    defineAsyncComponent({
        loader: () => import("@/components/ooi/pdf-validation.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "InvoicePrintLayout",
    defineAsyncComponent({
        loader: () => import("@/components/invoice/invoice-print-layout.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ReleaseCreate",
    defineAsyncComponent({
        loader: () => import("@/components/releases/release-create.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ReleaseMain",
    defineAsyncComponent({
        loader: () => import("@/components/releases/release-main.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "QuickStatus",
    defineAsyncComponent({
        loader: () => import("@/components/quickstatus/quick-status.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "StatusRowIcons",
    defineAsyncComponent({
        loader: () => import("@/components/quickstatus/status-row-icons.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "StatusUserContracts",
    defineAsyncComponent({
        loader: () =>
            import("@/components/quickstatus/status-user-contracts.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "StatusRow",
    defineAsyncComponent({
        loader: () => import("@/components/quickstatus/status-row.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CenterEditTitle",
    defineAsyncComponent({
        loader: () => import("@/components/basics/center-edit-title.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TwoButtons",
    defineAsyncComponent({
        loader: () => import("@/components/basics/two-buttons.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "RightSidebar",
    defineAsyncComponent({
        loader: () => import("@/components/basics/right-sidebar.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "DeleteSafety",
    defineAsyncComponent({
        loader: () => import("@/components/basics/delete-safety.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "TabSwitcher",
    defineAsyncComponent({
        loader: () => import("@/components/basics/tab-switcher.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CurrenciesPage",
    defineAsyncComponent({
        loader: () => import("@/components/currencies/currencies-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "CurrenciesEdit",
    defineAsyncComponent({
        loader: () => import("@/components/currencies/currencies-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ApitokenPage",
    defineAsyncComponent({
        loader: () => import("@/components/apitoken/apitoken-page.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);
app.component(
    "ApitokenEdit",
    defineAsyncComponent({
        loader: () => import("@/components/apitoken/apitoken-edit.vue"),
        loadingComponent: SimpleLoadingIcon,
        delay: 200,
        timeout: 30000,
    })
);


window.axios = axios;
window.axios.defaults.headers.common = {
    "X-CSRF-TOKEN": window.pagesettings.csrfToken,
    "X-Requested-With": "XMLHttpRequest",
    // "Authorization" : "Bearer " + pagesettings.user.api_token,
    // "Authorization" : "Bearer ",
    Accept: "application/json",
    "Content-Type": "application/json",
};

if (
    window.pagesettings.user !== null &&
    window.pagesettings.user !== undefined &&
    window.pagesettings.user.api_token != null &&
    window.pagesettings.user.api_token !== undefined &&
    window.pagesettings.user.api_token != ""
) {
    window.axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.pagesettings.user.api_token;
}

window.axios.defaults.withCredentials = true;
window.axios.defaults.baseURL = import.meta.env.VITE_APP_URL;
console.log(import.meta.env.VITE_APP_URL);



const pinia = createPinia();
app.use(pinia);

app.use(Router);
app.use(store);

function AxiosPiniaPlugin() {
    return {
        axios: window.axios,
    };
}
pinia.use(({ store }) => {
    store.router = markRaw(Router);
});
pinia.use(AxiosPiniaPlugin);


app.mixin({
    setup() {
        const actionStore = useActionStore();
        const currentUser = useCurrentUserStore();
        const {companyLocale} = useInternalCompany();
        return { actionStore, currentUser, companyLocale };
    },
    methods: {
        getUniq() {
            return (
                "_" +
                Math.random().toString(36).slice(-18) +
                "_" +
                Math.random().toString(36).slice(-18)
            );
        },
        async get_setting(string : string) {
            return getSetting(string);
        },
        async buildCache(array: any) {
            return buildCache(array);
        },
        actionNextStep() {
            for (let i in this.actionStore.actions) {
                if (
                    this.actionStore.actions[i].condition(this.$store) == true
                ) {
                    return this.actionStore.actions[i];
                }
            }
            return null;
        },
        can(flag : String) {
            return canfunc(flag);
        },
        cannot(flag : String) {
            return cannotfunc(flag);
        },
        __(key: string, para: any) {
            const languageStore = useLanguageStore();
            return languageStore.__(key, para);
        },
        __moment_date(date: string, format : string|boolean = false) {
            const currentUser = useCurrentUserStore() as CurrentUserStore;
            moment.locale(this.locale);
            var momentDate = moment.tz(date, "UTC");
            if (!momentDate.isValid()) {
                return "";
            }
            if(typeof format == "boolean"){
                format =
                    currentUser?.company_data?.settings?.date_format ?? "Y-m-d";
            }
            var timezone =
                currentUser.current_timezone ??
                currentUser.company_data?.settings?.date_timezone ??
                "UTC";
            if (!timezone || timezone == "") {
                timezone = "UTC";
            }
            return momentDate.tz(timezone).format(format as string);
        },
        __date(date: string, format:string|boolean = false) {
            if(!date || date == ""){
                return "";
            }
            const currentUser = useCurrentUserStore() as CurrentUserStore;
            moment.locale(this.locale);
            var momentDate = moment.tz(date, "UTC");
            if (!momentDate.isValid()) {
                return "";
            }
            if (format === false) {
                format =
                    currentUser.company_data?.settings?.date_format ?? "Y-m-d";
            }
            var timezone =
                currentUser.current_timezone ??
                currentUser.company_data?.settings?.date_timezone ??
                "UTC";
            if (!timezone || timezone == "") {
                timezone = "UTC";
            }
            return momentDate.tz(timezone).format(this.phpToMoment(format));
        },
        __datetime(date: string, format: string|boolean = false) {
            if(!date || date == ""){
                return "";
            }
            const currentUser = useCurrentUserStore() as CurrentUserStore;
            moment.locale(this.locale);
            var momentDate = moment.tz(date, "UTC");
            if (date == "" || !momentDate.isValid()) {
                return "";
            }
            if (format === false) {
                format =
                    currentUser.company_data?.settings?.date_format ?? "Y-m-d";
            }
            var timezone =
                currentUser.current_timezone ??
                currentUser.company_data?.settings?.date_timezone ??
                "UTC";
            if (!timezone || timezone == "") {
                timezone = "UTC";
            }
            return momentDate
                .tz(timezone)
                .format(this.phpToMoment(format) + " HH:mm");
        },
        phpToMoment(str: string) {
            let replacements: {[key: string] : string} = {
                d: "DD",
                D: "ddd",
                j: "D",
                l: "dddd",
                N: "E",
                S: "o",
                w: "e",
                z: "DDD",
                W: "W",
                F: "MMMM",
                m: "MM",
                M: "MMM",
                n: "M",
                t: "", // no equivalent
                L: "", // no equivalent
                o: "YYYY",
                Y: "YYYY",
                y: "YY",
                a: "a",
                A: "A",
                B: "", // no equivalent
                g: "h",
                G: "H",
                h: "hh",
                H: "HH",
                i: "mm",
                s: "ss",
                u: "SSS",
                e: "zz", // deprecated since Moment.js 1.6.0
                I: "", // no equivalent
                O: "", // no equivalent
                P: "", // no equivalent
                T: "", // no equivalent
                Z: "", // no equivalent
                c: "", // no equivalent
                r: "", // no equivalent
                U: "X",
            };

            return str
                .split("")
                .map((chr) => (chr in replacements ? replacements[chr] : chr))
                .join("");
        },
        __decimal(string: string, minDigits = 2, maxDigits: undefined|number = undefined) {
            if (typeof maxDigits == 'undefined' && maxDigits == undefined) {
                maxDigits = minDigits;
            }
            if (isNaN(parseFloat(string))) {
                return "";
            }
            return parseFloat(string).toLocaleString(this.companyLocale, {
                minimumFractionDigits: minDigits,
                maximumFractionDigits: maxDigits,
            });
        },
        calculateVolume(amount : any, entitys: any, formula: any) {
            if(!formula){
                return false;
            }
            var formulavalues: { [key: string]: any } = { amount: amount };

            for (const i in entitys) {
                formulavalues[entitys[i].unitname] =
                    entitys[i].size * entitys[i].rate;
            }

            var translatedFormula = this.translateFormula(
                formula,
                formulavalues
            );
            var calculatedValue = this.executeFormula(translatedFormula);

            if (calculatedValue === false) {
                return false;
            }
            // return amount * Math.random();
            return calculatedValue.toFixed(6);
        },
        translateFormula(formula: any, formulavalues: any) {
            var translatedFormula = formula;
            var variables = []; //debug
            var startPos = null;
            var endPos = null;

            for (var i = 0; i < formula.length; i++) {
                var currentChar = formula.charAt(i);
                if (currentChar == "{") {
                    startPos = i;
                }

                if (currentChar == "}") {
                    endPos = i + 1;
                }

                if (startPos !== null && endPos !== null) {
                    variables.push(formula.substring(startPos, endPos));
                    var variablePlaceholder = formula.substring(
                        startPos,
                        endPos
                    );
                    var variable = formula.substring(startPos + 1, endPos - 1);
                    var value = null;

                    if (formulavalues[variable] !== undefined) {
                        value = formulavalues[variable];
                    }

                    if (value !== null) {
                        translatedFormula = translatedFormula.replace(
                            variablePlaceholder,
                            value
                        );
                    }

                    startPos = null;
                    endPos = null;
                }
            }

            return translatedFormula;
        },
        interpretFormula(dimension: any, units: Array<any>) {
            const translatedDimension = [];
            const unitOrder = ["thickness", "width", "length"];

            let tmp: Record<string,string> = {
                size: "",
                unit: "",
                unitname: "",
                rate: "",
            };

            if (dimension === null || dimension === undefined) {
                dimension = "";
            }

            for (let i = 0; i < dimension.length; i++) {
                const currentChar = dimension.charAt(i);
                let detectedValue = null;
                let detectedType = null;

                // type declaration
                if (
                    this.isNumeric(currentChar) ||
                    currentChar == "." ||
                    currentChar == ","
                ) {
                    detectedValue = currentChar;
                    detectedType = "size";
                }

                if (
                    !this.isNumeric(currentChar) &&
                    currentChar != "." &&
                    currentChar != ","
                ) {
                    detectedValue = currentChar;
                    detectedType = "unit";
                }

                // separator = x oder whitespace. separator check muss der letzte aller checks sein => prio 1
                if (
                    currentChar.toLowerCase() == "x" ||
                    this.hasWhiteSpace(currentChar)
                ) {
                    detectedValue = currentChar;
                    detectedType = "separator";
                }

                // validation
                if (i == 0 && detectedType != "size") {
                    return false;
                }

                if (
                    i == dimension.length - 1 &&
                    this.hasWhiteSpace(currentChar)
                ) {
                    detectedValue = null;
                }

                if (typeof detectedValue == 'string' && detectedValue !== null) {
                    if (detectedType == "separator") {
                        translatedDimension.push(tmp);

                        tmp = {
                            size: "",
                            unit: "",
                            unitname: "",
                            rate: "",
                        };

                    } else {
                        if(detectedType != null){
                            tmp[detectedType] += detectedValue;
                        }
                    }
                }
            }

            translatedDimension.push(tmp);
            for (let i = 0; i < translatedDimension.length; i++) {
                if (unitOrder[i] != undefined) {
                    translatedDimension[i].unitname = unitOrder[i];
                }

                for (const j in units) {
                    if (
                        units[j].short_name != undefined &&
                        units[j].short_name["en"] != undefined
                    ) {
                        if (
                            units[j].short_name["en"] ==
                            translatedDimension[i].unit
                        ) {
                            translatedDimension[i].rate = units[j].rate;
                        }
                    }
                }
            }

            // 2. validation, sollte ein maß keine nummer beinhalten
            for (var i = 0; i < translatedDimension.length; i++) {
                if (
                    translatedDimension[i].size == "" ||
                    translatedDimension[i].rate == "" ||
                    translatedDimension[i].unitname == ""
                ) {
                    return false;
                }
            }

            return translatedDimension;
        },
        executeFormula(str: any) {
            for (var i = 0; i < str.length; i++) {
                if (
                    isNaN(str[i]) &&
                    !["+", "-", "/", "*", "%", "**", "."].includes(str[i])
                ) {
                    return NaN;
                }
            }

            try {
                return eval(str);
            } catch (e: any) {
                if (e.name !== "SyntaxError") throw e;
                return NaN;
            }
        },
        isNumeric(str = null) {
            if (typeof str != "string") return false; // we only process strings!
            return (
                !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                !isNaN(parseFloat(str))
            ); // ...and ensure strings of whitespace fail
        },
        hasWhiteSpace(s: string) {
            return /\s/g.test(s);
        },
        addNavTab(title: string, name: string, parameters = {}, duplicateIdent: string) {
            this.$store.commit("browserTabs/addTab", {
                route: {
                    duplicateIdentifier: duplicateIdent,
                    name: name,
                    params: parameters,
                    title: title,
                },
                triggerRedirect: false,
                router: this.$router,
            });
        },
        routeRedirect(
            _title : string,
            name : string,
            parameters = {},
            _duplicateIdentifier : any,
            hash = {}
        ) {
            this.$router.push({ name: name, params: parameters, hash: hash });
        },
    },
    computed: {
        user_first_day_of_week(){
            const currentUser = useCurrentUserStore() as CurrentUserStore;
            if(currentUser && currentUser.user && currentUser.user.profile && currentUser.user.profile.defaults && currentUser.user.profile.defaults.first_day_of_week){
                return currentUser?.user?.profile?.defaults?.first_day_of_week;
            }
            return 1;
        },
        possiblePageSizes() {
            return [
                {
                    name: "10",
                    value: 10,
                },
                {
                    name: "20",
                    value: 20,
                },
                {
                    name: "25",
                    value: 25,
                },
                {
                    name: "50",
                    value: 50,
                },
                {
                    name: "100",
                    value: 100,
                },
            ];
        },
        axios() {
            return window.axios;
        },
        locale() {
            const languageStore = useLanguageStore();
            return languageStore.locale ?? "en";
        },
    },
});

const emitter = mitt();
(window as any).Pusher = Pusher;
(window as any).emitter = app.config.globalProperties.emitter = emitter;
app.config.globalProperties._ = _;
app.config.globalProperties.Big = Big;
app.config.globalProperties.echo = (window).echo = new Echo({
    broadcaster: "pusher",
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    wsHost:
        window.location.hostname == "localhost"
            ? "127.0.0.1"
            : window.location.hostname,
    wssHost: window.location.hostname,
    authEndpoint: window.pagesettings.baseurl + "/broadcasting/auth",
    encrypted: false, //live true
    forceTLS: false, //live true
    wsPort: 6001,
    wssPort: 6001,
    disableStats: true,
    logToConsole: true, // live false
    enabledTransports: ["ws", "wss"], // live [ "ws", "wss"]
    authorizer: (channel : any, options: any) => {
        return {
            authorize: (socketId : any, callback: any) => {
                axios
                    .post(window.pagesettings.baseurl + "/api/broadcasting/auth", {
                        socket_id: socketId,
                        channel_name: channel.name,
                    })
                    .then((response) => {
                        callback(false, response.data);
                    })
                    .catch((error) => {
                        callback(true, error);
                    });
            },
        };
    },
});
app.mount("#app");
